/**
 * Time duration constants in milliseconds
 */

export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS; // 60,000ms
export const HOUR_IN_MS = 60 * MINUTE_IN_MS; // 3,600,000ms
export const DAY_IN_MS = 24 * HOUR_IN_MS; // 86,400,000ms
